<template>
  <div class="aps-page">
    <div class="public-breadcrumb">
      <router-link style="color: #6e6b7b" to="/">{{
        $t("devices.Welcome")
      }}</router-link>
      > {{ $t("devices.Devices") }} >
      <span style="color: #3461ff">{{ $t("devices.Inventory") }}</span>
    </div>
    <div class="card-bg aps-page_top">
      <el-button
        @click="handelAdd"
        class="aps-page_top-btn"
        icon="el-icon-plus"
        size="small"
        >{{ $t("devices.Add Inventory") }}</el-button
      >
    </div>
    <div class="card-bg aps-page_content">
      <div class="aps-page_content-top">
        <span>{{ $t("devices.records") }}: {{ pageParams.total }}</span>
        <el-select
          v-model="pageParams.storeType"
          placeholder=""
          size="small"
          @change="getList"
        >
          <el-option
            v-for="(item, i) in storeTypeList()"
            :key="i"
            :label="item.name"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="aps-page_content-table">
        <el-table
          :data="tableData"
          style="width: 100%; margin-bottom: 20px"
          row-key="coorId"
          v-loading="tableLoading"
          @sort-change="handleSort"
        >
          <!-- <el-table-column
            align="center"
            type="selection"
            style="display: none"
          >
            <el-table-column
              align="center"
              width="55"
              type="selection"
              style="display: none"
            >
            </el-table-column>
          </el-table-column> -->
          <el-table-column
            min-width="200"
            align="center"
            :label="$t('devices.aps.storeName')"
          >
            <el-table-column min-width="200" align="center" prop="storeName">
              <template slot="header" slot-scope="scope">
                <el-input
                  v-model="pageParams.storeName"
                  @input="getList"
                  size="small"
                  placeholder=""
                  clearable
                />
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            min-width="200"
            align="center"
            :label="$t('devices.inventory.InventoryName')"
            prop="name"
          >
            <el-table-column min-width="200" align="center" prop="name">
              <template slot="header" slot-scope="scope">
                <el-input
                  v-model="pageParams.name"
                  @input="getList"
                  size="small"
                  placeholder=""
                  clearable
                />
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            min-width="200"
            align="center"
            :label="$t('devices.inventory.operator')"
            prop="createUser"
          >
            <el-table-column min-width="200" align="center" prop="createUser">
              <template slot="header" slot-scope="scope">
                <el-input
                  v-model="pageParams.createUser"
                  @input="getList"
                  size="small"
                  placeholder=""
                  clearable
                />
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            min-width="200"
            align="center"
            :label="$t('devices.inventory.state')"
            prop="stateName"
          >
            <el-table-column min-width="200" align="center" prop="stateName">
              <template slot="header" slot-scope="scope">
                <el-select
                  v-model="pageParams.state"
                  placeholder=""
                  size="small"
                  clearable
                  @change="getList"
                >
                  <el-option
                    v-for="(item, i) in stateList"
                    :key="i"
                    :label="item.codeName"
                    :value="item.codeId"
                  />
                </el-select>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            min-width="240"
            align="center"
            :label="$t('devices.inventory.startTime')"
            sortable="custom"
            prop="startTime"
          >
            <el-table-column min-width="240" align="center" prop="startTime">
              <template slot="header" slot-scope="scope">
                <el-date-picker
                  v-model="pageParams.startTime"
                  type="daterange"
                  start-placeholder=""
                  end-placeholder=""
                  size="small"
                  @change="getList"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placement="bottom-start"
                  style="width: 100%"
                  clearable
                />
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            min-width="240"
            align="center"
            :label="$t('devices.inventory.endTime')"
            sortable="custom"
            prop="endTime"
          >
            <el-table-column min-width="240" align="center" prop="endTime">
              <template slot="header" slot-scope="scope">
                <el-date-picker
                  v-model="pageParams.endTime"
                  type="daterange"
                  start-placeholder=""
                  end-placeholder=""
                  size="small"
                  @change="getList"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placement="bottom-start"
                  style="width: 100%"
                  clearable
                />
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            align="center"
            min-width="200"
            :label="$t('devices.aps.remark')"
            prop="note"
          >
            <el-table-column align="center" min-width="200" prop="note">
              <template slot="header" slot-scope="scope"> </template>
            </el-table-column>
          </el-table-column>

          <el-table-column
            align="center"
            fixed="right"
            :label="$t('devices.aps.action')"
            width="80"
          >
            <el-table-column align="center" width="80">
              <template slot-scope="{ row }">
                <div class="action-wrapper">
                  <span
                    class="icon icon-info"
                    v-if="row.state != 3603"
                    @click="handelEnd(row)"
                  >
                    <i
                      class="el-icon-switch-button"
                      :title="$t('devices.inventory.closeInventory')"
                    ></i>
                  </span>
                  <span
                    class="icon"
                    @click="handleCheck(row)"
                    v-if="row.state == 3603"
                  >
                    <i
                      class="el-icon-view"
                      :title="$t('devices.inventory.checkReport')"
                    ></i>
                  </span>
                </div>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>

        <pagination :tableInfo="pageParams" @changePage="changePage" />
      </div>
    </div>

    <!-- add inventory -->
    <el-dialog
      :title="$t('devices.inventory.AddInventory')"
      :visible.sync="isVisibleAddDialog"
      class="communication-records_dialog"
      width="600px"
      :close-on-click-modal="false"
    >
      <add-inventory ref="form" :currentRow="currentRow"></add-inventory>
      <div slot="footer" class="dialog-footer">
        <el-button
          class="cancel-btn btn"
          size="small"
          @click="isVisibleAddDialog = false"
          >{{ $t("devices.cancel") }}</el-button
        >
        <el-button
          class="save-btn btn"
          size="small"
          type="primary"
          @click="handelSubmit"
          >{{ $t("devices.ok") }}</el-button
        >
      </div>
    </el-dialog>

    <!-- EndInventory step1 -->
    <el-dialog
      :title="$t('devices.inventory.EndInventory')"
      :visible.sync="isVisibleEndDialog1"
      class="communication-records_dialog"
      width="1000px"
      :close-on-click-modal="false"
    >
      <end-inventory-list
        ref="endList"
        :currentRow="currentRow"
      ></end-inventory-list>
      <div slot="footer" class="dialog-footer">
        <el-button
          class="cancel-btn btn"
          size="small"
          @click="handleEndCancel"
          >{{ $t("devices.cancel") }}</el-button
        >
        <el-button
          class="save-btn btn"
          size="small"
          type="primary"
          @click="handelEndNext"
          >{{ $t("devices.ok") }}</el-button
        >
      </div>
    </el-dialog>

    <!-- EndInventory step2 -->
    <el-dialog
      :title="$t('devices.inventory.EndInventory')"
      :visible.sync="isVisibleEndDialog2"
      class="communication-records_dialog"
      width="600px"
      :close-on-click-modal="false"
    >
      <end-inventory ref="endForm"></end-inventory>
      <div slot="footer" class="dialog-footer">
        <el-button
          class="cancel-btn btn"
          size="small"
          @click="isVisibleEndDialog2 = false"
          >{{ $t("devices.cancel") }}</el-button
        >
        <el-button
          class="save-btn btn"
          size="small"
          type="primary"
          @click="handelEndSubmit"
          >{{ $t("devices.ok") }}</el-button
        >
      </div>
    </el-dialog>

    <!-- 查看报告 -->
    <el-dialog
      :title="$t('devices.inventory.checkReport')"
      :visible.sync="isVisibleCheckDialog"
      class="communication-records_dialog"
      width="90%"
      :close-on-click-modal="false"
    >
      <check-report ref="checkWrap" :currentRow="currentRow"></check-report>
      <div slot="footer" class="dialog-footer">
        <el-button
          class="cancel-btn btn"
          size="small"
          @click="isVisibleCheckDialog = false"
          >{{ $t("devices.cancel") }}</el-button
        >
        <el-button class="save-btn btn" size="small" type="primary">{{
          $t("devices.ok")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import AddInventory from "./modules/AddInventory";
import EndInventoryList from "./modules/EndInventoryList";
import EndInventory from "./modules/EndInventory";
import CheckReport from "./modules/CheckReport";
import { commonStore } from "@/store/global-select-store";
import pagination from "@/components/pagination";
import { getCodeList } from "@/libs/api/aps";
import {
  getInventoryList,
  startInventory,
  completeInventory,
} from "@/libs/api/inventory";
import {
  COOR_STATE_CONNECTED,
  COOR_STATE_CONNECTING,
  storeTypeList,
  paginationEnum,
} from "@/libs/enum";
export default {
  name: "esls-inventory",
  components: {
    AddInventory,
    EndInventoryList,
    EndInventory,
    CheckReport,
    pagination,
  },
  data() {
    return {
      commonStore,
      paginationEnum,
      moment,
      storeTypeList,
      stateList: [],
      COOR_STATE_CONNECTED,
      COOR_STATE_CONNECTING,
      isVisibleAddDialog: false,
      isVisibleCheckDialog: false,
      isVisibleEndDialog1: false,
      isVisibleEndDialog2: false,
      currentRow: {},
      pageParams: {
        storeId: localStorage.getItem("storeId"), //	门店id
        current: 1, // 当前页
        size: 10,
        total: 0,
        state: "", // 盘点状态（待开始：3601、盘点中:3602、盘点完成:3603）
        storeType: 2, // 门店类型
        storeName: "", // 门店名称
        startDate: "", // 盘点开始时间
        endDate: "", // 盘点结束时间
        name: "", // 盘点名称
        createUser: "", // 操作人
        orders: [], // 排序字段
      },
      tableData: [],
      currentItem: {},
      ids: [],
      loading: false,
      tableLoading: false,
    };
  },
  methods: {
    handleEndCancel() {
      this.isVisibleEndDialog1 = false;
      this.getList();
    },
    // 表格排序
    handleSort(column, prop, order) {
      console.log("表格排序", column, prop, order);
      let arr = [];
      if (column.order) {
        let str1 = column.order === "ascending" ? "asc" : "desc";
        let prop = "";
        if (column.prop == "startTime") {
          prop = "start_time";
        }
        if (column.prop == "endTime") {
          prop = "end_time";
        }
        // str1 = str1 + ":" + column.prop;
        str1 = str1 + ":" + prop;
        arr.push(str1);
      } else {
        arr = [];
      }

      this.pageParams.orders = arr;
      this.getList();
    },
    changePage() {
      this.getList();
    },
    handleDateChange(val) {
      if (val) {
        this.pageParams.startDate = moment(val[0]).format("YYYY-MM-DD");
        this.pageParams.endDate = moment(val[1]).format("YYYY-MM-DD");
        this.pageParams.date = val;
      } else {
        this.pageParams.startDate = "";
        this.pageParams.endDate = "";
      }
      this.getList();
    },
    handelAdd() {
      this.isVisibleAddDialog = true;
    },
    handleCheck(row) {
      console.log(row);
      this.isVisibleCheckDialog = true;
      console.log(this.$refs.checkWrap);
      this.currentRow = row;

      this.$refs.checkWrap && this.$refs.checkWrap.getSummary();
    },

    handelEnd(row) {
      this.currentRow = row;
      this.isVisibleEndDialog1 = true;
    },
    handelEndNext() {
      this.isVisibleEndDialog1 = false;
      this.getList();
    },
    handelCancel() {
      this.currentRow = {};
      this.isVisibleEditeDialog = false;
    },
    async handelSubmit() {
      try {
        this.$refs.form.$refs["ruleForm"].validate(async (valid) => {
          if (valid) {
            const ruleForm =
              this.$refs && this.$refs.form && this.$refs.form.ruleForm
                ? this.$refs.form.ruleForm
                : {};

            const { name, storeIds, tagTypeId, note } = ruleForm;
            const params = {
              name,
              storeIds: storeIds.join(","),
              tagTypeId: tagTypeId.join(","),
              note: note,
            };
            this.loading = true;
            const { data } = await startInventory(params);
            if (data.state === true) {
              this.isVisibleAddDialog = false;
              this.$message.success(this.$t("devices.startSuccess"));
              this.getList();
            } else {
              this.$message.error(data.message);
            }
            this.loading = false;
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      } catch (err) {
        const { message } = err;
        this.$message.error(message);
        this.loading = false;
      }
    },
    async handelEndSubmit() {
      console.log(123);
      try {
        this.$refs.endForm.$refs["ruleForm"].validate(async (valid) => {
          if (valid) {
            const ruleForm =
              this.$refs && this.$refs.endForm && this.$refs.endForm.ruleForm
                ? this.$refs.endForm.ruleForm
                : {};
            console.log(this.currentRow);
            const params = {
              ...ruleForm,
              id: this.currentRow.batchId,
            };
            this.loading = true;
            const { data } = await completeInventory(params);
            if (data.state === true) {
              this.isVisibleEndDialog2 = false;
              this.$message.success(this.$t("devices.operationSuccess"));
              this.getList();
            } else {
              this.$message.error(data.message);
            }
            this.loading = false;
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      } catch (err) {
        const { message } = err;
        this.$message.error(message);
        this.loading = false;
      }
    },
    getList() {
      this.tableData = [];
      let params = this.pageParams;
      getInventoryList(params).then((res) => {
        // console.log(res);
        this.tableData = res.data.data.records;
        this.pageParams.total = res.data.data.total;
      });
    },

    handleSelectionChange(data) {
      let ids = [];
      data.forEach((item) => {
        ids.push(item.coorId);
      });
      this.ids = ids;
    },
    async getCodeList() {
      try {
        const { data } = await getCodeList({ cateId: 36 });
        if (data.state === true) {
          this.stateList = data.data || [];
        } else {
          this.$message.error(data.message);
        }
      } catch (err) {
        const { message } = err;
        this.$message.error(message);
      }
    },
  },
  created() {
    commonStore.setInjectCallBack(this.getList);
    this.getList();
    this.getCodeList();
  },
  computed: {
    language() {
      return this.$store.state.appConfig.language;
    },
  },
  watch: {
    isVisibleAddDialog(val) {
      console.log("123", val);
      if (!val) {
        // this.$refs.ruleForm
        console.log(this.$refs.form.$refs["ruleForm"]);
        console.log(this.$refs.form);
        console.log(this.$refs.form.$refs);
        this.$refs.form.reset()
        // const addRefs = this.$refs.form.$refs

        // console.log(addRefs);
        // const ruleForm = addRefs.ruleForm
        // //初始化赋值
        // ruleForm.resetFields()
        // // 清空验证
        // ruleForm.clearValidate()
        // this.$refs.form.ruleForm = {
        //   name: "",
        //   storeIds: "",
        //   storeNames: "",
        //   tagTypeId: [],
        //   note: "",
        // };
        //   ruleForm: {
        //   name: '',
        //   storeIds: '',
        //   storeNames: '',
        //   tagTypeId: [],
        //   note: ''
        // },
      }
    },
    language(val) {
      if (val) this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.aps-page {
  .card-bg {
    background: #ffffff;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.05);
    border-radius: 6px;
  }
  &_top ::v-deep {
    padding: 20px;
    margin-bottom: 20px;
    .el-button {
      // width: 180px;1
      // height: 50px;
      background: #3461ff;
      border-radius: 8px;
      // font-size: 18px;
      color: #ffffff;
      i {
        margin-right: 5px !important;
      }
    }
  }
  &_content {
    &-top {
      padding: 15px;
      font-size: 12px;
      // color: #999999;
      > span {
        margin-right: 10px;
      }
    }
    &-table ::v-deep {
      // .el-table
      //   .el-table__header-wrapper
      //   .el-table__header
      //   .is-group
      //   tr:nth-of-type(2)
      //   th:nth-of-type(1)
      //   .cell {
      //   display: none;
      // }
      .action-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 30px;
        color: rgba(47, 59, 97, 1);
        // font-size: 20px;
        .icon {
          margin: 0 5px;
          color: rgba(47, 59, 97, 1);
          cursor: pointer;
          font-size: 21px;
        }
        .icon-info {
          font-size: 19px;
        }
        .icon-info:before {
          content: "";
        }
      }
      .coor-state {
        padding: 3px 18px;
        text-align: center;
        border-radius: 15px;
        display: inline-block;
      }
      .state-connected {
        background: rgba(217, 250, 232, 1);
      }
      .state-connecting {
        background: rgba(193, 233, 255, 1);
      }
    }
  }
  .dialog-footer ::v-deep {
    text-align: center;
    .el-button {
      width: 110px;
      height: 40px;
    }

    .btn {
      // border-radius: 10px;
    }
    .el-button.cancel-btn {
      background: #d4d4d4 !important;
      box-shadow: 0px 1px 15px 0px rgba(99, 99, 99, 0.23);
      color: #626262;
    }
    .el-button.save-btn {
      background: #35b871 !important;
      box-shadow: 0px 1px 15px 0px rgba(53, 184, 113, 0.55);
      color: #ffffff;
    }
  }
  .dialog-footer ::v-deep {
    text-align: center;
    .el-button {
      width: 110px;
      height: 40px;
      border: none;
    }
    .el-button.cancel-btn {
      background: #d4d4d4 !important;
      box-shadow: 0px 1px 15px 0px rgba(99, 99, 99, 0.23);
      color: #626262;
    }
    .el-button.save-btn {
      background: #35b871 !important;
      box-shadow: 0px 1px 15px 0px rgba(53, 184, 113, 0.55);
      color: #ffffff;
    }
  }
}
</style>